import RecipientForm from 'features/Recipient/RecipientForm';
import React from 'react';

const RecipientsFormView = () => {
  return (
    <>
      <RecipientForm />
    </>
  );
}

export default RecipientsFormView;
